import React from "react";
import notFound from "../../images/not_found.png";
import serverError from "../../images/server_error.png";
import { Link, useLocation } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();
  const title = location.state?.title || "Seems like you have lost your way.";
  const status = location.state?.status || "900";

  return (
    <section className="mt-5 mb-5 text-center">
      <div className="container text-center">
        <h4>{title}</h4>
        <img src={status !== 404 ? notFound : serverError} />
      </div>
      <Link to="/">
        <button className="btn homePageButton">Go To Home</button>
      </Link>
    </section>
  );
};

export default NotFound;
